module.exports = __webpack_public_path__ + "static/media/stroller-cleaning-service.a3c2112f.webp";